import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import animateScrollTo from 'animated-scroll-to';
// import PostcardEdit from './elements/PostcardEdit';
import axios from 'axios';

const PostcardDetail = (props) => {
  const { card, cardId, setSelectedCard, height } = props;
  const service = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/api`,
  });

  const [display, setDisplay] = useState(true);
  const [currentCard, setCurrentCard] = useState(card);
  const [imageF, setImageF] = useState(null);
  const [imageB, setImageB] = useState(null);
  const [frontLoaded, setFrontLoaded] = useState(false);
  const [backLoaded, setBackLoaded] = useState(false);

  const close = () => {
    setDisplay(false);
    props.history.goBack();
  };

  const getSelectedCard = (cardId) => {
    service
      .get(`/postcard/${cardId}`)
      .then((card) => {
        setCurrentCard(card.data);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    getSelectedCard(cardId);
    setDisplay(true);
    animateScrollTo(height || 0);
    if (!card && cardId) {
      setCurrentCard(card);
      setSelectedCard(card);
    }
  }, [cardId]);

  useEffect(() => {
    if (card) {
      setImageF(card.imageFront || null);
      setImageB(card.imageBack || null);
      setFrontLoaded(false);
      setBackLoaded(false);
    }
  }, [card && card._id]);

  if (currentCard && display) {
    const { QTH, year, continent, country, indicator, region } = currentCard;
    const placeLine = [QTH, region].filter(Boolean).join(', ');
    const countryLine = [country, continent].filter(Boolean).join(', ');

    return (
      <section className="page detail">
        <div className="postcard-wrapper">
          {imageF && (
            <div className={`postcard-img${frontLoaded ? '' : ' loading'}`}>
              <img
                src={imageF}
                alt={indicator}
                onLoad={() => setFrontLoaded(true)}
                onError={() => setFrontLoaded(true)}
              />
            </div>
          )}
          {imageB && (
            <div className={`postcard-img${backLoaded ? '' : ' loading'}`}>
              <img
                src={imageB}
                alt={indicator}
                onLoad={() => setBackLoaded(true)}
                onError={() => setBackLoaded(true)}
              />
            </div>
          )}
        </div>
        <div className="postcard-detail-data">
          <div className="data-group">
            <p>{indicator}</p>
            <p>{year}</p>
          </div>
          <div className="data-group">
            <p>{placeLine}</p>
            <p>{countryLine}</p>
          </div>
          {/* <PostcardEdit card={card} setCurrentCard={setCurrentCard} /> */}
        </div>

        <div className="close-detail" onClick={close} id="closeIcon">
          <div className="closeIcon1">
            <div className="closeIcon2"></div>
          </div>
        </div>
      </section>
    );
  }
  return null;
};

export default withRouter(PostcardDetail);
